import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router'
import { Observable } from 'rxjs/Rx'
import { AuthenticationService, User } from '../../theme/shared'

@Injectable()
export class AdminAuthGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _authService: AuthenticationService
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const user = this._authService.getCurrentUserCookie()
    if (user) {
      if (user != null && user.type == User.ROLE.ADMINISTRATOR) return true
      return this.handleError(state, false)
    }
    return this.handleError(state, true)
  }
  private handleError(state: RouterStateSnapshot, logout: boolean) {
    if (logout) {
      this._router.navigate(['/login'], {
        queryParams: { returnUrl: state.url }
      })
    } else {
      this._router.navigate(['/'])
    }
    return false
  }
}
